import React from 'react';
import PropTypes from 'prop-types';

class ScrollToTop extends React.Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (this.props.children.key !== prevProps.children.key) {
      window.scroll(0, 0);
    }
  }

  render() {
    // Enforce one child only
    return React.Children.only(this.props.children);
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ScrollToTop;
